export default {
  control: (styles, { isDisabled }) => ({
    ...styles,
    ':hover': {
      ...styles[':hover'],
      border: '1px 1px 1px 0 solid #B2B2B2',
      borderColor: '#B2B2B2',
    },
    ':focus': {
      ...styles[':focus'],
      border: '1px 1px 1px 0 solid #B2B2B2',
      borderColor: '#B2B2B2',
    },
    ':active': {
      ...styles[':active'],
      border: '1px 1px 1px 0 solid #B2B2B2',
      borderColor: '#B2B2B2',
    },
    borderColor: 'rgba(178,178,178,0.5)',
    borderRadius: '0 6px 6px 0',
    backgroundColor: '#FFFFFF',
    boxShadow: 'inset 0 2px 0px 0 rgba(0,0,0,0.2)',
    boxSizing: 'borderBox',
    borderLeft: '0',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? '#B2B2B2' : '#FFFFFF',
      paddingTop: '2px',
      paddingBottom: '2px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#FFFFFF',
        color: '#333333',
      },
      ':hover': {
        ...styles[':hover'],
        backgroundColor: '#E87721',
        color: '#ffffff',
      },
    }
  },
  input: (styles) => ({
    ...styles,
    ':hover': {
      ...styles[':hover'],
      border: '1px 1px 1px 0 solid #B2B2B2',
    },
    ':focus': {
      ...styles[':focus'],
      border: '1px 1px 1px 0 solid #B2B2B2',
    },
    ':active': {
      ...styles[':active'],
      border: '1px 1px 1px 0 solid #B2B2B2',
    },
  }),
  placeholder: (styles) => ({ ...styles }),
  singleValue: (styles, { data }) => ({ ...styles }),
  indicatorSeparator: (styles) => ({
    ...styles,
    width: 0,
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
    color: '#333333 !important',
    ':hover': {
      color: '#333333  !important',
    },
  }),
}
